module.exports = __webpack_public_path__ + "img/white-arrow.8ce91cc0.svg";